let TenantSlugs;
if (process.env.REACT_APP_MODE === "PROD") {
    TenantSlugs = {
        seedworks: "35",
        sudama: "38",
        century: "39",
        ultimatrue: "36",
        siyaram: "37",
        modenik: "25",
        cavin: "42",
        borosil: "33",
        aqualite: "27",
        lancer: "32",
        skdreams: "43",
        talbros: "49",
        lotus: "45",
        bch: "50",
        vox: "51",
        zeel: "52",
        bikaji: "41",
        iffco: "61",
        vox: "51"
    };
}
// (serverConfig.mode === EnvModes.DEV)

else {
    TenantSlugs = {
        ultimatrue: "17",
        sudama: "41",
        century: "43",
        seedworks: "44",
        siyaram: "46",
        modenik: "25",
        cavin: "47",
        borosil: "38",
        aqualite: "27",
        lancer: "39",
        skdreams: "49",
        talbros: "53",
        lotus: "50",
        bch: "52",
        vox: "55",
        zeel: "57",
        bikaji: "48",
        iffco: "61",
        goodwill: "64"
    };
}

export default TenantSlugs;
